import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import BolgedekiTekliflerimTable from "../../components/bolgedekiTekliflerim/table/BolgedekiTekliflerimTable"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import InputCityTownBolgedekiTekliflerim from "../../components/shared/input/bolgedekiTekliflerim/InputLocationBolgedekiTekliflerim"
import Btn from "../../components/shared/button/Btn"
import { useState } from "react"
import { showModal } from "../../features/modal/modalSlice"
import { addOrUpdateBolgeTeklif, getBolgedekiTekliflerim, setBolgedekiTeklifItem, addNewBolgeTeklifRow, setAnyQuery } from "../../features/bolgedekiTekliflerim/bolgedekiTekliflerimSlice"
import InputLocationCity from "../../components/shared/input/bolgedekiTekliflerim/InputLocationCity"
import locationData, { locationDataAllSpecific } from "../../utils/locationData/locationOptions"
import InputLocationTown from "../../components/shared/input/bolgedekiTekliflerim/InputLocationTown"
const Container = styled.div`
    width: 100%;

    .wrapper{
        width: 100%;
        display: flex;
        flex-direction: column;
        min-height: 500px;

        .content{
          padding: 30px;
          display: flex;
          flex-direction: column;

          .top-container{
            display: flex;
            width: 100%;
            justify-content: space-between;

            .filter-wrapper{
              display: flex;
              align-items: center;
              gap: 10px;

              .seperator{
                height: 35px;
                width: 2px;
                background-color: ${({theme}) => theme.secondaryTextColor};
              }
            }

          }

          .table-container{
            width: 100%;
            display: flex;
            overflow-x: auto;
            position: relative;
            min-height: 70vh;
            max-height: 70vh;

            .from-container{
              display: flex;
              flex-direction: column;
              position: absolute;
              left: 0;
              top: 0;
              padding-top: 50px;

              .th-list{
                display: flex;
                text-align: center;

                .th-item-first{
                  border-right: 1px solid #fff;
                  background-color: ${({theme}) => theme.mainBgColor};
                  width: 50px;
                  height: 37px;
                  background-color: var(--color-main);
                }

                .th-item-second{
                  background-color: ${({theme}) => theme.mainBgColor};
                  width: 501px;
                  height: 37px;
                  background-color: var(--color-main);
                  border-right: 1px solid #fff;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  padding-left: 10px;

                  .settings-icon{
                    font-size: 1.2rem;
                    cursor: pointer;
                    color: #fff;
                  }
                }

                .th-item{
                  width: 250px;
                  height: min-content;
                  background-color: var(--color-main);
                  color: #fff;
                  padding: 10px 5px;
                  border: 1px solid #fff;
                  font-size: var(--font-size-sm);
                  font-weight: var(--font-weight-lg);

                  &:first-child{
                    border: 1px solid var(--color-main);
                    border-right: 1px solid ${({theme}) => theme.mainBgColor};
                    border-top: 1px solid ${({theme}) => theme.mainBgColor};
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                  }

                  &:nth-child(2){
                    border-left: 1px solid var(--color-main);
                    border-right: 1px solid var(--color-main);
                  }
                  
                  &:last-child{
                    border-right: 1px solid var(--color-main);

                  }



                }
              }

              .td-list{
                display: flex;
                flex-direction: column;


                .td-item-container{
                  display: flex;

                  .td-item{
                    width: 250px;
                    height: min-content;
                    background-color: ${({theme}) => theme.mainBgColor};
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    height: 35px;
                    border: 1px solid ${({theme}) => theme.mainTextColor};
                    border-top: none;
                    
                    &:first-child{
                      border-right: none;
                      background-color: #fff;
                      width: 35px;
                      height: 35px;
                    }
                    
                    &:nth-child(2){
                      border-right: none;
                    }

                    &:last-child{
                      border-right: none;
                    }

                    .more-icon{
                      font-size: 1.2rem;
                      cursor: pointer;
                    }
                  }

                  .delete-container{
                    
                    .delete-text{
                      font-size: var(--font-size-sm);
                      font-weight: var(--font-weight-lg);
                      color: var(--color-main);
                      text-decoration: underline;
                      cursor: pointer;
                    }
                  }
                }
              }
            }
          }

          .empty-list-container{
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 40px;
            padding-top: 120px;

            p{
              font-size: var(--font-size-md);
              font-weight: var(--font-weight-lg);
            }
          }

      }

    }
`

const BolgedekiTekliflerim = () => {

  const {bolgedekiTeklifler, constantBolgedekiTeklifler, hiddenAracColumnList, anyQuery } = useSelector(state => state.bolgedekiTekliflerim)
  const [hoveredItem, setHoveredItem] = useState(null)

  const [fromCity, setFromCity] = useState("")
  const [fromTown, setFromTown] = useState("")
  const [toCity, setToCity] = useState("")
  const [toTown, setToTown] = useState("")

  const [fromTownOptions, setFromTownOptions] = useState([])
  const [toTownOptions, setToTownOptions] = useState([])

  const dispatch = useDispatch()
  

  useEffect(() => {
    dispatch(getBolgedekiTekliflerim({
      fromCityId: fromCity?.cityId ? parseInt(fromCity?.cityId) : "",
      fromTownId: fromTown?.townId ? parseInt(fromTown?.townId) : "",
      toCityId: toCity?.cityId ? parseInt(toCity?.cityId) : "",
      toTownId: toTown?.townId ? parseInt(toTown?.townId): ""
    }))
  },[fromCity, fromTown, toCity, toTown])


  useEffect(() => {
    if(fromCity?.cityId){
      const list = locationData.filter(item => {
        return item.cityId === fromCity?.cityId
      })
      setFromTownOptions(list)
    }
  },[fromCity?.cityId])

  useEffect(() => {
    if(toCity?.cityId){
      const list = locationData.filter(item => {
        return item.cityId === toCity?.cityId
      })
      setToTownOptions(list)
    }
  },[toCity?.cityId])

  useEffect(() => {

    if(fromCity?.cityId || fromTown?.townId || toCity?.cityId || toTown?.townId){
      dispatch(setAnyQuery(true))
    }else{
      dispatch(setAnyQuery(false))
    }
  },[fromCity?.cityId, fromTown?.townId, toCity?.cityId, toTown?.townId])


  useEffect(() => {
    const filteredBolgedekiTeklifler = bolgedekiTeklifler.filter(item => {
      return item.fromTownId && item.toTownId
    })

    if(filteredBolgedekiTeklifler.length === bolgedekiTeklifler.length && !anyQuery){
      dispatch(addNewBolgeTeklifRow())
    }
  },[bolgedekiTeklifler, anyQuery])


  useEffect(()=> {
      setFromTown("")
  },[fromCity?.cityId])


  useEffect(()=> {
      setToTown("")
  },[toCity?.cityId])

  const handleClear = () => {
    setFromCity("")
    setFromTown("")
    setToCity("")
    setToTown("")
  }

  const handleSubmit = () => {

    //! bu aynı mı değil mi diye?
    const filtered = bolgedekiTeklifler.filter((item) => {
      const jsonString1 = JSON.stringify(item);
      const jsonString2 = JSON.stringify(constantBolgedekiTeklifler.find(innerItem => innerItem.id === item.id));
      return jsonString1 !== jsonString2
    }).filter(item => {
      return (item.fromTownId && item.toTownId && typeof item.id !== "string")
    })


    //! bu mevcutta yoksa ve yeni eklenmişse
    const addedList = bolgedekiTeklifler.filter((item) => {
      return typeof item.id === "string" && item.fromTownId && item.toTownId
    }).map(item => {
      return {...item, id:null}
    })

    
    dispatch(addOrUpdateBolgeTeklif([...filtered, ...addedList]))
  }


  return (
    <Container>
        <div className="wrapper">
        <PageTopTitle title={"Bölgedeki Tekliflerim"} position='sticky'/>
          <div className="content">
            <div className="top-container">
              <div className="filter-wrapper">
                <InputLocationCity data={fromCity?.city} setData={setFromCity} labelText={"Nereden İl"} initialOptions={locationDataAllSpecific} inputWidth={"220px"} name={"fromCity"}/>
                {
                  fromCity?.city &&
                  <InputLocationTown data={fromTown?.town} setData={setFromTown} labelText={"Nereden İlçe"} initialOptions={fromTownOptions} inputWidth={"220px"} name={"fromTown"}/>
                }
                <div className="seperator"/>
                <InputLocationCity data={toCity?.city} setData={setToCity} labelText={"Nereye İl"} initialOptions={locationDataAllSpecific} inputWidth={"220px"} name={"toCity"}/>
                {
                  toCity?.city &&
                  <InputLocationTown data={toTown?.town} setData={setToTown} labelText={"Nereye İlçe"} initialOptions={toTownOptions} inputWidth={"220px"} name={"toTown"}/>
                }
                {
                  (fromCity?.cityId || toCity?.cityId) &&
                  <Btn bgColor="#fff" color="#E85446" borderColor="#E85446" width={"160px"} handleClick={handleClear}>Filtreyi Temizle</Btn>
                }
              </div>

              <Btn bgColor="#E85446" color="#fff" width={"220px"} handleClick={handleSubmit}>Kaydet</Btn>
            </div>
            {
              bolgedekiTeklifler.length > 0 ?
              <div className="table-container">
                <div className="from-container">
                  <div className="th-list">
                    <div className="th-item-first"></div>
                    <div className="th-item-second">
                      {/* <IoMdSettings className="settings-icon"/> */}
                    </div>
                  </div>
                  <div className="th-list">
                    <div className="th-item" style={{backgroundColor: "var(--color-main)", width:"50px", height: "37px" }}>
                      
                    </div>
                    <div className="th-item">Nereden</div>
                    <div className="th-item">Nereye</div>
                  </div>
                  <div className="td-list">
                  {
                    bolgedekiTeklifler.map((item, i) => (
                      <div className="td-item-container" key={item.id}>
                          <div className="td-item delete-container" onMouseEnter={() => setHoveredItem(item)} onMouseLeave={() => setHoveredItem(null)} style={{backgroundColor: "#fff", width:"49px", height: "35px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            {
                              (hoveredItem?.id === item.id && typeof item.id !== "string" && item.fromTownId && item.toTownId) ? 
                              <span className="delete-text" onClick={() => {dispatch(setBolgedekiTeklifItem(item)); dispatch(showModal("deletePermissionBolgedekiTeklifItem"))}}>Sil</span>
                              :
                              <div>{i+1}</div>
                            }
                        </div>
                        <div className="td-item">
                          <InputCityTownBolgedekiTekliflerim item={item} townId={item.fromTownId} name={`${i}nereden`} keyData={"from"} placeholder={"İl/İlçe seçiniz"}/>
                        </div>
                        <div className="td-item">
                          <InputCityTownBolgedekiTekliflerim item={item} townId={item.toTownId} name={`${i}nereye`} keyData={"to"} placeholder={"İl/İlçe seçiniz"}/>
                        </div>
                      </div>
                    ))
                  }
                  </div>
                </div>
                <BolgedekiTekliflerimTable bolgedekiTeklifler={bolgedekiTeklifler} hiddenAracColumnList={hiddenAracColumnList}/>
              </div>
              :
              <div className="empty-list-container">
                <p>Teklif Bulunamadı</p>
              </div>
            }

          </div>
        </div>
    </Container>
  )
}

export default BolgedekiTekliflerim